// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page":"page_xzM-i","page_item":"page_item_0MAPD","page_label":"page_label_z9w1Z","page_img":"page_img_KtyTM","page_title":"page_title_CERr5"};